// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DELETED_REASON = "D\u016fvod";
export const POST_IS_DELETED_FIND_WHY__IN_CODEX = ", pros\u00edm, co je u n\u00e1s v po\u0159\u00e1dku a co ne.";
export const POST_IS_DELETED_FIND_WHY__READ = "P\u0159e\u010dti si";
